module.exports = __webpack_public_path__ + "static/media/BK_LOGO_PRIMARY_®_ST_MAYO_EGG_WHITE_RGB.07fd3a3a.PNG";